import { Alert } from "@mui/material";
import { useSpring, animated } from "@react-spring/web";

import React, { useEffect } from "react";

function ErrorAlert({ message, show, setShow }) {
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
    }, 4000);
    return () => clearTimeout(timeout);
  }, [show]);

  const props = useSpring({
    opacity: show ? 1 : 0,
    height: show ? 40 : 0,
    marginBottom: show ? 10 : 0,
  });
  return (
    <animated.div style={{ ...props, maxWidth: 900 }}>
      <Alert
        severity="error"
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        {message ? message : " An error occured, please try again"}
      </Alert>
    </animated.div>
  );
}

export default ErrorAlert;
